import { useContext } from "react";
import { HRLocaleContext } from "../hr/i18n/HRLocaleProvider";
import en from "./copy/en.js";
import tr from "./copy/tr.js";

const BUNDLES = { en, tr };

// Returns the OnHuman.tech copy bundle for the locale shared with OnHuman HR,
// so switching language on either site switches both.
export default function useTechCopy() {
  const { locale } = useContext(HRLocaleContext);
  return BUNDLES[locale] || en;
}
